import { useEffect } from "react";
import { Drawer as VDrawer } from "vaul";
import { Badge } from "@components/Badge/Badge";
import { type IModalProps } from "@components/Modal/Modal";

export const Drawer: React.FC<IModalProps> = (props) => {
  const {
    modal,
    badgeProps,
    title,
    subtitle,
    children,
    actionButtons,
    displayDrawerHandle,
  } = props;

  // Drawer doesn't provide unmount event, so we need to remove it manually
  const onCLose = () => {
    modal.close();
    setTimeout(() => {
      modal.remove();
    }, 300);
  };

  useEffect(() => {
    if (!modal.state.open) {
      modal.remove();
    }
  }, [modal, modal.state.open]);

  const showTopPart = badgeProps ?? title ?? subtitle;

  return (
    <VDrawer.Root
      open={modal.state.open}
      onClose={onCLose}
      dismissible={!modal.important}
    >
      <VDrawer.Portal>
        <div className="relative z-50">
          <VDrawer.Overlay className="fixed inset-0 bg-base-black/40 backdrop-blur-[6px] transition-opacity" />
          <VDrawer.Content className="fixed bottom-0 left-0 right-0 mt-24 flex flex-col rounded-t-2xl bg-white">
            {displayDrawerHandle && (
              <div className="flex items-center justify-center py-2">
                <div className="h-[0.3125rem] w-12 rounded-full bg-grey-light"></div>
              </div>
            )}
            {showTopPart && (
              <div className="px-4 py-5">
                {badgeProps && (
                  <Badge
                    className="mb-4"
                    variant="rounded"
                    icon={badgeProps.icon}
                    size="medium"
                    color={badgeProps.color ?? "green"}
                  />
                )}
                {title && (
                  <VDrawer.Title className="text-gray-900 text-lg font-medium leading-6">
                    {title}
                  </VDrawer.Title>
                )}
                {subtitle && (
                  <h6 className="pt-1 font-normal text-[#707070]">
                    {subtitle}
                  </h6>
                )}
              </div>
            )}
            {children && <div>{children}</div>}
            {actionButtons && (
              <div className="flex flex-1 items-end">
                <div className="flex w-full flex-row gap-3 border-t border-grey-light px-4 py-5">
                  {actionButtons}
                </div>
              </div>
            )}
          </VDrawer.Content>
        </div>
      </VDrawer.Portal>
    </VDrawer.Root>
  );
};
